var map = {
	"./ar.json": 772,
	"./en.json": 773,
	"./localise_stf/ar.json": 366,
	"./localise_stf/en.json": 367,
	"./menu_ar.json": 368,
	"./menu_en.json": 369,
	"./menu_kw_ar.json": 281,
	"./menu_kw_en.json": 282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 771;